module.exports = __webpack_public_path__ + "media/images/redesign-images/higher-ed/cayla-image-504c3c0bf8ccf59104811715598ff922.jpg";